import type { IconData } from '../../types';

export const data: IconData = {
  o: '<path d="M846-624q31 0 55 24 25 24 25 56v56l1 17q1 9-2 16L796-158q-11 26-36 44-26 18-55 18H259v-528l205-218q18-19 42-24 24-4 46 7t32 35q10 23 3 48l-32 152h291Zm-514 40v409h386l127-302v-67H461l48-228-177 188ZM139-96q-33 0-56-23t-23-56v-369q0-33 23-56 23-24 56-24h120v80H139v369h120v79H139Zm193-79v-409 409Z"/>',
  f: '<path d="M851-624q31 0 55 25 25 24 25 55v56q0 12-3 28t-8 27L801-158q-10 26-36 44t-55 18H320q-33 0-56-23t-23-56v-417q0-15 6-29 5-14 17-26l180-191q17-18 42-23t47 7q22 11 32 34 11 23 5 49l-31 147h312ZM121-96q-25 0-43-17-17-18-17-43v-408q0-24 17-42t41-18h2q24 0 42 18t18 42v408q0 25-18 43-18 17-42 17Z"/>',
};

export default data;
